'use client'

import { clsx } from 'clsx'
import Script from 'next/script'
import { type FC } from 'react'
import useSWRImmutable from 'swr/immutable'

import { useGetExperimentForTenant } from '../experiments/hooks'
import { EXPERIMENT_HEADER_STICKY_TOGGLE } from '../experiments/model/EXPERIMENT_NAME_PER_TENANT'
import { experimentAccessorNonDefault } from '../experiments/model/experimentAccessor'
import { gtmDataLayerWaitTillEventLoaded } from '../gtm'

import { type AppsFlyerBannerConfig } from './appsFlyerBannerGetConfig'

import styles from './AppsFlyerBanner.module.css'

const APPS_FLYER_CONTAINER_ID = 'apps-flyer-container'

const eventFetcher = async (): ReturnType<
  typeof gtmDataLayerWaitTillEventLoaded
> =>
  gtmDataLayerWaitTillEventLoaded({
    eventName: 'gtm.data.loaded',
    timeout: 2000,
  })

type AppsFlyerBannerProps = { config: AppsFlyerBannerConfig }

export const AppsFlyerBanner: FC<AppsFlyerBannerProps> = ({ config }) => {
  const { key } = config

  const { data } = useSWRImmutable('gtm.data.loaded', eventFetcher)

  const headerStickyToggleExperiment = useGetExperimentForTenant(
    EXPERIMENT_HEADER_STICKY_TOGGLE,
  )
  const isHeaderStickyToggleExperimentDefault = experimentAccessorNonDefault(
    headerStickyToggleExperiment,
  )

  return (
    <>
      <div
        className={clsx(
          styles['apps-flyer-banner'],
          isHeaderStickyToggleExperimentDefault &&
            styles['apps-flyer-banner-sticky-header-experiment'],
        )}
        id={APPS_FLYER_CONTAINER_ID}
      />
      {data ? (
        <Script id="apps-flyer">
          {/*
           * https://jira.shop-apotheke.com/browse/CRO-671
           * https://dev.appsflyer.com/hc/docs/dl_smart_banner_v2#smart-banners-only
           */}
          {`
!function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){
(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},
t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,
o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),
p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","banners",{banners: {key: "${key}"}});

AF('banners', 'showBanner', { bannerContainerQuery: '#${APPS_FLYER_CONTAINER_ID}', bannerZIndex: 'auto' });
dataLayer.push({ event: 'af_banner' });
        `}
        </Script>
      ) : null}
    </>
  )
}
